const {h, render, Component} = require('preact');
const OrderStatusContainer = require('../../containers/status/order_status')
const Web2018Helper = require('../../../helper')

class Order extends Component {
  constructor(props) {
    super(props);
  };

  getMerchantName() {
    return (<div class="merchant-name-text"> {this.props.order.merchant.name}</div>)
  }

  getOrderId() {
    return (<div class="b title">
      <span>{I18n.translate("js.modules.support.order_no")}: </span>
      <span>{this.props.order.id}</span>
    </div>)
  }

  getPurchaseDate() {
    if (this.props.order && this.props.order.purchasedAtshortDatetimeStr) {
      return (
        <div>
          <span>{I18n.translate("js.modules.support.puron")}</span>
          <span> {Web2018Helper.getDateStringWithDay(this.props.order.purchasedAtshortDatetimeStr)}</span>
        </div>
      );
    }
    return null;
  }

  getQuantity() {
    let order = this.props.order;
    let quantity = 0;
    if (order && order.groupons && order.groupons.length > 0) {
      order.groupons.forEach(function (groupon) {
        if (groupon.availability && groupon.availability.toLowerCase() !== "refunded" && groupon.purchaseStatus && groupon.purchaseStatus.toLowerCase() !== "refunded") {
          quantity++;
        }
      });
    }
    return (
      <div><span>{I18n.translate("js.modules.support.qty")}</span>
        <span>{quantity}</span>
      </div>
    )
  }

  getTotalAmount() {
    return (<div class="order-total">{this.props.order.purchaseHistory.formattedTotalPrice}</div>)
  }

  getImage() {
    return (
      <div className="five columns order-description">
        <img src={this.props.order.deal.largeImageUrl} class="image-area" alt="Deal Image"/>
      </div>
    )
  }

  getOrderDetails() {
    return (
      <div class="order-info cell-column">
        {this.getMerchantName()}
        {this.getOrderId()}
        {this.getPurchaseDate()}
        {this.getQuantity()}
        {this.getTotalAmount()}
      </div>
    )
  }

  render() {
    let order = this.props.order;
    if (order) {
      return (
        <div>
          {this.getImage()}
          {this.getOrderDetails()}
        </div>

      )
    }
  }
}

module.exports = Order
